import { generateConfidenceColors } from "./generateConfidenceColors";
const primary = "51.0% 0.167 265.815"; // blue
const content = "38.5% 0.006 67.634"; // fg

export const tempusDayTheme = {
  name: "tempus-day",
  default: false,
  prefersDark: false,
  colorScheme: "light",
  colors: {
    "base-100": "96.2% 0.018 86.147", // bg
    "base-200": "92.0% 0.020 86.000", // interpolated
    "base-300": "87.0% 0.022 86.000", // interpolated
    "base-content": "38.5% 0.006 67.634", // fg
    "primary": "51.0% 0.167 265.815", // Color4
    "primary-content": "96.2% 0.018 86.147", // bg
    "secondary": "52.3% 0.139 307.762", // Color13
    "secondary-content": "96.2% 0.018 86.147", // bg
    "accent": "50.5% 0.073 231.232", // Color14
    "accent-content": "96.2% 0.018 86.147", // bg
    "neutral": "87.0% 0.022 86.000", // base-300
    "neutral-content": "38.5% 0.006 67.634", // fg
    "info": "51.3% 0.168 256.137", // Color12
    "info-content": "96.2% 0.018 86.147", // bg
    "success": "49.9% 0.090 143.195", // Color10
    "success-content": "96.2% 0.018 86.147", // bg
    "warning": "50.3% 0.106 103.481", // Color11
    "warning-content": "38.5% 0.006 67.634", // fg
    "error": "52.7% 0.211 30.137", // Color1
    "error-content": "96.2% 0.018 86.147", // bg
    ...generateConfidenceColors(primary, content, false)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.25rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "0",
    "noise": "0"
  }
};
